<template>
  <v-layout class="mt-4" justify-center>
    <v-flex xs8>
      <v-card class="tabs_style">
        <v-tabs centered color="primary" dark text grow v-model="tabSelected">
          <v-tabs-slider color="secondary"></v-tabs-slider>

          <v-tab
            v-if="isAccountAdmin"
            href="#tab-1"
            class="text-capitalize"
          >{{$translate('PARTNERS')}}</v-tab>
          <v-tab href="#tab-2" class="text-capitalize">{{$translate('CUSTOMERS')}}</v-tab>
          <v-tab href="#tab-3" class="text-capitalize">{{$translate('TRIPS')}}</v-tab>
          <v-tab href="#tab-4" class="text-capitalize">{{$translate('SUGGESTIONS')}}</v-tab>
          <v-tab href="#tab-5" class="text-capitalize">{{$translate('DIRECT_BOOKING')}}</v-tab>

          <v-tab-item v-for="i in tabsNumber" :key="i" :value="`tab-${i}`" justify-center>
            <v-container grid-list-xl text-xs-center>
              <Statistics-Partners
                v-if="i==1 && loadComponents"
                :partners="partners"
                class="tab_container"
              />
              <Statistics-Users
                v-if="i==2 && loadComponents"
                :isAccountAdmin="isAccountAdmin"
                :partnerOptions="partnerOptions"
                :timeSteps="timeSteps"
                class="tab_container"
              />
              <Statistics-Trips
                v-if="i==3 && loadComponents"
                :isAccountAdmin="isAccountAdmin"
                :partnerOptions="partnerOptions"
                :timeSteps="timeSteps"
                class="tab_container"
              />
              <Statistics-Suggestions
                v-if="i==4 && loadComponents"
                :isAccountAdmin="isAccountAdmin"
                :partnerOptions="partnerOptions"
                :timeSteps="timeSteps"
                class="tab_container"
              />
              <Statistics-DirectBookings
                v-if="i==5 && loadComponents"
                :isAccountAdmin="isAccountAdmin"
                :partnerOptions="partnerOptions"
                :timeSteps="timeSteps"
                class="tab_container"
              />
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import BaseObject from "@/objects/BaseObject";
import _ from "lodash";
import { mapGetters } from "vuex";
import Statistics_Partners from "./Statistics_Partners";
import Statistics_Users from "./Statistics_Users";
import Statistics_Trips from "./Statistics_Trips";
import Statistics_Suggestions from "./Statistics_Suggestions";
import Statistics_DirectBookings from "./Statistics_DirectBookings";

export default {
  name: "Statistics_Main",
  components: {
    "Statistics-Partners": Statistics_Partners,
    "Statistics-Users": Statistics_Users,
    "Statistics-Trips": Statistics_Trips,
    "Statistics-Suggestions": Statistics_Suggestions,
    "Statistics-DirectBookings": Statistics_DirectBookings,
  },

  data() {
    return {
      isAccountAdmin: false,
      partnerActive: false,
      loadComponents: false,
      tabsNumber: 5,
      tabSelected: null,
      partners: [],
      partnerOptions: [],
      timeSteps: 4,
    };
  },

  beforeDestroy() {
    let page = "Statistics_Main";
    this.$store.commit("setCurrentComponent", page);
  },

  created() {},

  mounted() {
    if (this.$store.getters["auth/userLevel"] >= 9) {
      this.isAccountAdmin = true;
      this.tabSelected = "tab-1";
      this.getPartners();
    } else {
      this.tabSelected = "tab-2";
      this.getPartner();
    }
  },

  methods: {
    getPartners() {
      // Action for loading all the Partners in the current account
      const payload = {
        FunctionId: "AccountFunctionLibrary::getPartners",
      };
      dssRequest.doRequest(
        (response) => {
          console.log("the call for getPartners was successful", response);
          this.partners = [];
          this.partnerOptions = [{ PartnerId: 0, PartnerName: "All partners" }];
          response.data.PartnerList.forEach((partnerObj) => {
            this.partners.push({
              PartnerId: Number(partnerObj.PartnerId),
              PartnerName: partnerObj.Name,
              PartnerLevel: partnerObj.PartnerLevel
            });
            this.partnerOptions.push({
              PartnerId: Number(partnerObj.PartnerId),
              PartnerName: partnerObj.Name,
            });
          });

          this.loadComponents = true;
        },
        (error) => {
          console.log("the call for getPartners was not successful", error);
        },
        "communicateWithDBLibrary",
        this.$store.getters.getCurrentAccountId,
        payload
      );
    },

    getPartner() {
      // Get the data of a specific partner
      const payload = {
        PartnerId: this.$store.getters["auth/partnerId"],
        FunctionId: "EventFunctionLibrary::getPartner",
      };
      dssRequest.doRequest(
        (response) => {
          console.log("the call for getPartner was successful", response);
          let nameIndex = Number(response.data.Partner.columns.Name);
          this.partnerOptions.push({
            PartnerId: this.$store.getters["auth/partnerId"],
            PartnerName: response.data.Partner.celldata[0][nameIndex],
          });
          this.loadComponents = true;
        },
        (error) => {
          console.log("the call for getPartner was not successful", error);
        },
        "communicateWithDBLibrary",
        this.$store.getters.getCurrentAccountId,
        payload
      );
    },
  },
};
</script>

<style lang="scss", scoped>
.tab_container {
  height: 70vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.tabs_style {
  border-radius: 2em;
}
</style>
